"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var analytics_client_1 = require("@tableau/analytics-client");
var data_structures_1 = require("@tableau/data-structures");
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetDatasourcesWithConnectabilityDetailsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDatasourcesWithConnectabilityDetailsMethod");
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
var Localize_1 = require("../../gen-src/Localize");
var FilterPanel_1 = require("../components/FilterPanel/FilterPanel");
var MessageUtils_1 = require("../displayUtils/MessageUtils");
var ConnectToDatabasesConnectionParamsQueryGql_1 = require("../queries/ConnectToDatabasesConnectionParamsQueryGql");
var ConnectToTablesConnectionParamsQueryGql_1 = require("../queries/ConnectToTablesConnectionParamsQueryGql");
var ConnectToDatabasesSortProvider_1 = require("../sorting/sortProviders/ConnectToDatabasesSortProvider");
var ConnectToDatasourcesSortProvider_1 = require("../sorting/sortProviders/ConnectToDatasourcesSortProvider");
var ConnectToTablesSortProvider_1 = require("../sorting/sortProviders/ConnectToTablesSortProvider");
var StyleFunctions_1 = require("../style/StyleFunctions");
var DataCatalogProvider_1 = require("../wrappers/DataCatalogProvider");
var SelectionProvider_1 = require("../wrappers/SelectionProvider");
var ConnectToDialogBottomPanel_1 = require("./ConnectToDialogBottomPanel");
var ConnectToDialogFilterPanel_1 = require("./ConnectToDialogFilterPanel");
var ConnectToDialogFunctions_1 = require("./ConnectToDialogFunctions");
var ConnectToDialogStyles_1 = require("./ConnectToDialogStyles");
var ConnectToDialogTopPanel_1 = require("./ConnectToDialogTopPanel");
var ConnectToErrorHandling_1 = require("./ConnectToErrorHandling");
var ConnectToLogger_1 = require("./ConnectToLogger");
var ConnectToTelemetryContext_1 = require("./ConnectToTelemetryContext");
var ConnectToDatabasesQueryGrid_1 = require("./QueryGrids/ConnectToDatabasesQueryGrid");
var ConnectToDatasourcesQueryGrid_1 = require("./QueryGrids/ConnectToDatasourcesQueryGrid");
var ConnectToTablesQueryGrid_1 = require("./QueryGrids/ConnectToTablesQueryGrid");
var ConnectToDialog = /** @class */ (function (_super) {
    __extends(ConnectToDialog, _super);
    function ConnectToDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.localIsMounted = false;
        // Converts the input string to either Databases or Tables. Returns a null if the string is either
        // undefined or unsupported.
        _this.convertStringToSupportedPreselectedDataTypes = function (value) {
            if (value === 'Databases') {
                return 'Databases';
            }
            else if (value === 'Tables') {
                return 'Tables';
            }
            else {
                return null;
            }
        };
        _this.onClosed = function () {
            return;
        };
        _this.onDataTypeChange = function (dataType) {
            _this.setState({
                filterStates: __assign(__assign({}, _this.state.filterStates), { certifiedState: false, connectionTypeState: ConnectToDialogFilterPanel_1.defaultSelectionValue, dataQualityWarningState: ConnectToDialogFilterPanel_1.defaultSelectionValue, filtersApplied: false }),
                selectedDataType: dataType
            });
            _this.onClosed();
        };
        _this.clearSearch = function () {
            _this.setState({
                inProgressSearchText: '',
                filterStates: __assign(__assign({}, _this.state.filterStates), { querySearchText: '' })
            });
        };
        _this.handleKeyDown = function (e, clearSelection) {
            if (e.key === 'Enter') {
                _this.sendSearchQuery(clearSelection);
            }
        };
        _this.updateSearchText = function (e) {
            _this.setState({ inProgressSearchText: e.target.value });
        };
        _this.sendSearchQuery = function (clearSelection) {
            if (clearSelection) {
                clearSelection();
            }
            _this.setState(function (prevState) {
                return {
                    filterStates: __assign(__assign({}, prevState.filterStates), { querySearchText: _this.state.inProgressSearchText }),
                    telemetryInfoNumSearches: prevState.telemetryInfoNumSearches + 1,
                };
            });
        };
        // The connection params we get back from graphql calls can have default values that don't necessarily make sense, so this function
        // is to change those values to better defaults for consumption.
        _this.getCorrectConnectionParams = function (connectionParams) {
            // This is the start of the daisy chain. Add more calls as we need to.
            return _this.getCorrectPortValues(connectionParams);
        };
        _this.getCorrectPortValues = function (connectionParams) {
            // If port is less than 0, then remove port from the connectionParams
            if (connectionParams.port && connectionParams.port < 0) {
                var port = connectionParams.port, remainingConnectionParams = __rest(connectionParams, ["port"]);
                return remainingConnectionParams;
            }
            return connectionParams;
        };
        _this.onDatasetSelected = function (selectedKeys, client) { return function () { return __awaiter(_this, void 0, void 0, function () {
            var payload, connectionParams, correctedConnectionParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = new Map();
                        payload.set('actionType', 'onDatasetSelected');
                        payload.set('numSearches', this.state.telemetryInfoNumSearches.toString());
                        payload.set('selectedDataType', this.state.selectedDataType.toString());
                        return [4 /*yield*/, this.getConnectionParamsForSelectedRow(selectedKeys, client)];
                    case 1:
                        connectionParams = _a.sent();
                        if (connectionParams !== null) {
                            correctedConnectionParams = this.getCorrectConnectionParams(connectionParams);
                            this.props.onDatasetSelected(correctedConnectionParams);
                            if (correctedConnectionParams.connectionType) {
                                payload.set('connectionType', correctedConnectionParams.connectionType.toString());
                            }
                            if (correctedConnectionParams.dataType) {
                                payload.set('dataType', correctedConnectionParams.dataType.toString());
                            }
                        }
                        this.emitConnectToTelemetry(payload);
                        return [2 /*return*/];
                }
            });
        }); }; };
        _this.getConnectionParamsForSelectedRow = function (selectedKeys, client) { return __awaiter(_this, void 0, void 0, function () {
            var selectedRowId, _a, data, selectedDatabase, getDatasources, slice, data, selectedTable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        selectedRowId = Object.keys(selectedKeys)[0];
                        _a = this.state.selectedDataType;
                        switch (_a) {
                            case 'Databases': return [3 /*break*/, 1];
                            case 'Datasources': return [3 /*break*/, 3];
                            case 'Tables': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, client.query({
                            query: ConnectToDatabasesConnectionParamsQueryGql_1.ConnectToDatabasesConnectionParamsQueryGql,
                            variables: { databaseId: selectedRowId }
                        })];
                    case 2:
                        data = (_b.sent()).data;
                        selectedDatabase = data.databasesConnection.nodes[0];
                        return [2 /*return*/, ConnectToDialogFunctions_1.getConnectionParamsForDatabase(this.state.selectedDataType, selectedDatabase)];
                    case 3:
                        getDatasources = this.props.vizPortalWebClientRequester.createSender(GetDatasourcesWithConnectabilityDetailsMethod_1.GetDatasourcesWithConnectabilityDetailsMethod);
                        return [4 /*yield*/, getDatasources(new vizportal_webclient_api_1.GetItemsParams({
                                startIndex: 0,
                                maxItems: 1
                            }, {
                                clauses: [vizportal_webclient_api_1.Filter.stringFieldEq('repositoryUrl', selectedRowId), vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)],
                                operator: IFilterClause_1.FilterOps.and
                            }))];
                    case 4:
                        slice = _b.sent();
                        if (ConnectToDialogFunctions_1.isSessionTimeOut(slice)) {
                            this.setState({ sessionTimeOut: true });
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(slice) && ConnectToDialogFunctions_1.isIGetDatasourcesResult(slice.response.result))
                                ? ConnectToDialogFunctions_1.getConnectionParamsForDatasource(slice.response.result)
                                : null];
                    case 5: return [4 /*yield*/, client.query({
                            query: ConnectToTablesConnectionParamsQueryGql_1.ConnectToTablesConnectionParamsQueryGql,
                            variables: { tableId: selectedRowId }
                        })];
                    case 6:
                        data = (_b.sent()).data;
                        selectedTable = data.databaseTablesConnection.nodes[0];
                        return [2 /*return*/, ConnectToDialogFunctions_1.getConnectionParamsForTable(this.state.selectedDataType, selectedTable)];
                    case 7: 
                    // This is practically unreachable as the connect button is disabled for no selection.
                    // We can't assert it however, as non-practical code paths lead here.
                    return [2 /*return*/, null];
                }
            });
        }); };
        _this.updateDatabaseTotalCount = function (totalCount) {
            _this.setState({ totalCountDatabase: totalCount });
        };
        _this.updateDatasourceTotalCount = function (totalCount) {
            _this.setState({ totalCountDatasource: totalCount });
        };
        _this.updateTableTotalCount = function (totalCount) {
            _this.setState({ totalCountTable: totalCount });
        };
        _this.updateTotalRows = function (numberOfRows) {
            var payload = new Map();
            payload.set('actionType', 'updateTotalRows');
            payload.set('numRows', numberOfRows.toString());
            payload.set('selectedDataType', _this.state.selectedDataType.toString());
            _this.emitConnectToTelemetry(payload);
        };
        _this.updateAvailableFilterOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            var connectionTypes, dQWOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ConnectToDialogFilterPanel_1.getAvailableConnectionTypesAndCounts(this.state.selectedDataType, this.state.filterStates, this.props.vizPortalWebClientRequester)];
                    case 1:
                        connectionTypes = _a.sent();
                        connectionTypes.unshift({
                            content: Localize_1.Messages.ConnectionTypeFilterDefaultContent(),
                            displayValueWhenSelected: Localize_1.Messages.ConnectionTypeFilterDefaultContent(),
                            value: ConnectToDialogFilterPanel_1.defaultSelectionValue
                        });
                        return [4 /*yield*/, ConnectToDialogFilterPanel_1.getAvailableDataQualityWarningSelections(this.props.apolloClient, this.state.selectedDataType, this.state.filterStates)];
                    case 2:
                        dQWOptions = _a.sent();
                        dQWOptions.unshift({
                            content: Localize_1.Messages.DataQualityWarningFilterDefaultContent(),
                            displayValueWhenSelected: Localize_1.Messages.DataQualityWarningFilterDefaultContent(),
                            value: ConnectToDialogFilterPanel_1.defaultSelectionValue
                        });
                        this.setState({
                            filterStates: __assign(__assign({}, this.state.filterStates), { availableConnectionTypeFilterOptions: connectionTypes, availableDataQualityWarningFilterOptions: dQWOptions, visibleFilterNames: ConnectToDialogFilterPanel_1.visibleFiltersByDataType.get(this.state.selectedDataType) })
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onFilterPanelStateChange = function (name, newState) {
            var filterStatesClone = __assign({}, _this.state.filterStates);
            switch (name) {
                case ConnectToDialogFilterPanel_1.certifiedFilterName:
                    var newValue = newState.booleanValue || false;
                    filterStatesClone = __assign(__assign({}, filterStatesClone), { certifiedState: newValue });
                    break;
                case ConnectToDialogFilterPanel_1.connectionTypeFilterName:
                    var labelsToDsClasses = filterStatesClone.connectionTypeLabelsToClasses;
                    var newConnectionType = labelsToDsClasses && newState.textValue ?
                        labelsToDsClasses.get(newState.textValue) : ConnectToDialogFilterPanel_1.defaultSelectionValue;
                    filterStatesClone = __assign(__assign({}, filterStatesClone), { connectionTypeState: newConnectionType || ConnectToDialogFilterPanel_1.defaultSelectionValue });
                    break;
                case ConnectToDialogFilterPanel_1.dataQualityWarningFilterName:
                    filterStatesClone = __assign(__assign({}, filterStatesClone), { dataQualityWarningState: newState.textValue || ConnectToDialogFilterPanel_1.defaultSelectionValue });
                    break;
                default:
                    break;
            }
            var newFiltersAppliedState = ConnectToDialogFilterPanel_1.anyFilterApplied(filterStatesClone);
            _this.setState({
                filterStates: __assign(__assign({}, filterStatesClone), { filtersApplied: newFiltersAppliedState })
            });
        };
        _this.onToggleFilterPanel = function () {
            _this.setState({
                filterStates: __assign(__assign({}, _this.state.filterStates), { filterPanelIsDisplayed: !_this.state.filterStates.filterPanelIsDisplayed })
            });
        };
        _this.getConnectToFilterProps = function () {
            var result = new Map();
            result.set(ConnectToDialogFilterPanel_1.connectionTypeFilterName, ConnectToDialogFilterPanel_1.createSelectionFilter(ConnectToDialogFilterPanel_1.connectionTypeFilterName, function () { return _this.state.filterStates.availableConnectionTypeFilterOptions || []; }, function (value) { return ConnectToDialogFilterPanel_1.getDisplayValueFromItems(value, _this.state.filterStates.availableConnectionTypeFilterOptions); }, true, Localize_1.Messages.GridHeaderConnectionType(), MessageUtils_1.messageForConnectionType(_this.state.filterStates.connectionTypeState)));
            result.set(ConnectToDialogFilterPanel_1.dataQualityWarningFilterName, ConnectToDialogFilterPanel_1.createSelectionFilter(ConnectToDialogFilterPanel_1.dataQualityWarningFilterName, function () { return _this.state.filterStates.availableDataQualityWarningFilterOptions || []; }, function (value) { return ConnectToDialogFilterPanel_1.getDisplayValueFromItems(value, _this.state.filterStates.availableDataQualityWarningFilterOptions); }, false, Localize_1.Messages.DataQualityWarningTitle(), _this.state.filterStates.dataQualityWarningState));
            result.set(ConnectToDialogFilterPanel_1.certifiedFilterName, ConnectToDialogFilterPanel_1.createBooleanFilter(ConnectToDialogFilterPanel_1.certifiedFilterName, Localize_1.Messages.GridHeaderCertified(), _this.state.filterStates.certifiedState));
            return result;
        };
        _this.state = {
            filterStates: ConnectToDialogFilterPanel_1.getIntitialConnectToDialogFilterPanelState(),
            inProgressSearchText: '',
            isCatalogingEnabled: false,
            roleAllowsViewingDatasources: false,
            selectedDataType: 'NoSelection',
            telemetryInfoNumSearches: 0,
            totalCountDatabase: null,
            totalCountDatasource: null,
            totalCountTable: null,
            sessionTimeOut: false,
            catalogSevereWarningsEnabled: false
        };
        return _this;
    }
    ConnectToDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.localIsMounted = true;
        ConnectToDialogFunctions_1.getSessionInfo(this.props.vizPortalWebClientRequester).then(function (sInfo) { return __awaiter(_this, void 0, void 0, function () {
            var sessionInfo, isCatalogingEnabled, roleAllowsViewingDatasources, catalogSevereWarningsEnabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!!sInfo && !!sInfo.fetchResponse && sInfo.fetchResponse.fetchResponse.status === 401)) return [3 /*break*/, 1];
                        this.setState(__assign(__assign({}, this.state), { sessionTimeOut: true }));
                        return [3 /*break*/, 3];
                    case 1:
                        sessionInfo = (!!sInfo && !!sInfo.sessionInfo) ? sInfo.sessionInfo : null;
                        isCatalogingEnabled = !!sessionInfo && !!sessionInfo.site.catalogingOnSiteEnabled;
                        roleAllowsViewingDatasources = this.showDatasourcesBasedOnSiteRole(sessionInfo);
                        catalogSevereWarningsEnabled = this.getCatalogSevereWarningsEnabled(sessionInfo);
                        return [4 /*yield*/, this.setComponentData(isCatalogingEnabled, roleAllowsViewingDatasources, catalogSevereWarningsEnabled)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }).catch(function (err) {
            ConnectToLogger_1.ConnectToLogger.error('GetSessionInfo did not succeed. Catalog will be unavailable.' + err);
        });
    };
    ConnectToDialog.prototype.componentWillUnmount = function () {
        this.localIsMounted = false;
    };
    ConnectToDialog.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!this.props.isFilterPanelAvailable) {
            return;
        }
        var newFilterStates = this.state.filterStates;
        var prevFilterStates = prevState.filterStates;
        if (this.state.selectedDataType !== prevState.selectedDataType
            || newFilterStates.certifiedState !== prevFilterStates.certifiedState
            || newFilterStates.dataQualityWarningState !== prevFilterStates.dataQualityWarningState
            || newFilterStates.connectionTypeState !== prevFilterStates.connectionTypeState
            || newFilterStates.querySearchText !== prevFilterStates.querySearchText) {
            this.updateAvailableFilterOptions().catch(function (err) {
                ConnectToLogger_1.ConnectToLogger.error('Failed to fetch required info to populate filter panel. ' + err);
            });
        }
    };
    ConnectToDialog.prototype.setComponentData = function (isCatalogingEnabled, roleAllowsViewingDatasources, catalogSevereWarningsEnabled) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedDataType, preselectedDatatype, selectedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        preselectedDatatype = this.convertStringToSupportedPreselectedDataTypes(this.props.preselectedDataType);
                        if (isCatalogingEnabled && preselectedDatatype != null) {
                            selectedDataType = preselectedDatatype; // author from catalog places page
                        }
                        else if (roleAllowsViewingDatasources) {
                            if (this.props.isNewDatasource) {
                                selectedDataType = 'Datasources';
                            }
                            else {
                                selectedDataType = (isCatalogingEnabled && !this.props.showDatasourceOnly) ? 'Tables' : 'NoSelection';
                            }
                        }
                        else {
                            selectedDataType = (isCatalogingEnabled && !this.props.showDatasourceOnly) ? 'Tables' : 'NoSelection';
                        }
                        if (this.localIsMounted) {
                            this.setState(__assign(__assign({}, this.state), { selectedDataType: selectedDataType, roleAllowsViewingDatasources: roleAllowsViewingDatasources, isCatalogingEnabled: isCatalogingEnabled, catalogSevereWarningsEnabled: catalogSevereWarningsEnabled }));
                        }
                        if (!(preselectedDatatype != null && this.props.preselectedGraphQLId != null)) return [3 /*break*/, 2];
                        selectedItem = data_structures_1.stringListToKeySet([this.props.preselectedGraphQLId]);
                        return [4 /*yield*/, this.onDatasetSelected(selectedItem, this.props.apolloClient)()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ConnectToDialog.prototype.emitConnectToTelemetry = function (payload) {
        if (this.props.telemetryContext != undefined) {
            if (this.props.telemetryContext.telemetryEnvironment != undefined &&
                this.props.telemetryContext.telemetryEnvironment !== ConnectToTelemetryContext_1.ConnectToTelemetryEnvironment.Disabled) {
                var reporter = new analytics_client_1.Reporter('https://analytics.tableausoftware.com');
                var eventBuilder = new analytics_client_1.AnalyticsEventFactory('ConnectToDialog', '', '');
                var payloadValue_1 = "appSessionId=" + this.props.telemetryContext.appSessionId + ";";
                payloadValue_1 += "dialogSessionId=" + this.props.telemetryContext.dialogSessionId + ";";
                payloadValue_1 += "machineId=" + this.props.telemetryContext.machineId + ";";
                payloadValue_1 += "telemetryEnvironment=" + this.props.telemetryContext.telemetryEnvironment + ";";
                payloadValue_1 += "dialogReleaseVersion=2020.2;";
                payload.forEach(function (value, key) {
                    payloadValue_1 = payloadValue_1.concat(key + "=" + value + ";");
                });
                var event_1 = eventBuilder.createEvent()
                    .ofType('connectToUsage')
                    .withProperty('payload', payloadValue_1)
                    .build();
                reporter.reportEvent(event_1);
            }
        }
    };
    ConnectToDialog.prototype.getCatalogSevereWarningsEnabled = function (sessionInfo) {
        if (!sessionInfo || !sessionInfo.server) {
            return false;
        }
        return sessionInfo.server.featureFlags.catalogSevereWarningsEnabled || false;
    };
    ConnectToDialog.prototype.showDatasourcesBasedOnSiteRole = function (sInfo) {
        var upperCaseRole = (sInfo && sInfo.site.role ? sInfo.site.role : '').toUpperCase();
        return upperCaseRole !== 'VIEWER' && upperCaseRole !== 'UNLICENSED';
    };
    ConnectToDialog.prototype.renderGrid = function (selectedKeys, updateSelectionForKey) {
        var _this = this;
        switch (this.state.selectedDataType) {
            case 'Databases':
                return (React.createElement(ConnectToDatabasesSortProvider_1.ConnectToDatabasesGridSortProvider, null, function (_a) {
                    var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                    return React.createElement(ConnectToDatabasesQueryGrid_1.ConnectToDatabasesQueryGrid, { allowedClasses: _this.props.allowedClasses, apolloClient: _this.props.apolloClient, filterStates: _this.state.filterStates, orderBy: orderBy, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder, updateTotalCount: _this.updateDatabaseTotalCount });
                }));
            case 'Datasources':
                return (React.createElement(ConnectToDatasourcesSortProvider_1.ConnectToDatasourcesGridSortProvider, null, function (_a) {
                    var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                    return React.createElement(ConnectToDatasourcesQueryGrid_1.ConnectToDatasourcesQueryGrid, { filterStates: _this.state.filterStates, orderBy: orderBy, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder, updateTotalCount: _this.updateDatasourceTotalCount, vizPortalWebClientRequester: _this.props.vizPortalWebClientRequester });
                }));
            case 'Tables':
                return (React.createElement(ConnectToTablesSortProvider_1.ConnectToTablesGridSortProvider, null, function (_a) {
                    var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                    return React.createElement(ConnectToTablesQueryGrid_1.ConnectToTablesQueryGrid, { allowedClasses: _this.props.allowedClasses, apolloClient: _this.props.apolloClient, filterStates: _this.state.filterStates, orderBy: orderBy, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder, updateTotalCount: _this.updateTableTotalCount });
                }));
            default:
                return null;
        }
    };
    ConnectToDialog.prototype.renderFilterPanel = function (clearSelection) {
        var _this = this;
        if (!this.props.isFilterPanelAvailable || !this.state.filterStates.filterPanelIsDisplayed) {
            return null;
        }
        var onFilterPanelStateChange = function (name, newState) {
            if (clearSelection) {
                clearSelection();
            }
            _this.onFilterPanelStateChange(name, newState);
        };
        return (React.createElement(FilterPanel_1.FilterPanel, { filterProps: this.getConnectToFilterProps(), onFilterPanelStateChange: onFilterPanelStateChange, visibleFilterNames: this.state.filterStates.visibleFilterNames }));
    };
    ConnectToDialog.prototype.render = function () {
        var _this = this;
        // Special styles needed for hybrid dialog (desktop) to work properly
        var connectToDialogContainerClassName = this.props.isDesktop
            ? StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogContainerForDesktop) : StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogContainerForWeb);
        var connectToDataGridClassName = this.props.isDesktop
            ? StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogGridContainerForDesktop) : StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogGridContainerForWeb);
        return (React.createElement(DataCatalogProvider_1.FeatureFlagsProvider, { featureFlags: { catalogSevereWarningsEnabled: this.state.catalogSevereWarningsEnabled, catalogTagsEnabled: false } },
            React.createElement(SelectionProvider_1.SingleSelectionProvider, { selectionId: this.state.selectedDataType }, function (_a) {
                var selectedKeys = _a.selectedKeys, updateSelectionForKey = _a.updateSelectionForKey, clearSelection = _a.clearSelection;
                return React.createElement("div", { className: connectToDialogContainerClassName },
                    React.createElement(ConnectToDialogTopPanel_1.ConnectToDialogTopPanel, { clearSearch: _this.clearSearch, filtersApplied: _this.state.filterStates.filtersApplied, inProgressSearchText: _this.state.inProgressSearchText, isCatalogingEnabled: _this.state.isCatalogingEnabled, isFilterPanelAvailable: _this.props.isFilterPanelAvailable, isNewDatasource: _this.props.isNewDatasource, onDataTypeChange: _this.onDataTypeChange, onKeyDown: function (e) { return _this.handleKeyDown(e, clearSelection); }, onToggleFilter: _this.onToggleFilterPanel, roleAllowsViewingDatasources: _this.state.roleAllowsViewingDatasources, selectedDataType: _this.state.selectedDataType, showDatasourceOnly: _this.props.showDatasourceOnly, totalCountDatabase: _this.state.totalCountDatabase, totalCountDatasource: _this.state.totalCountDatasource, totalCountTable: _this.state.totalCountTable, updateSearchText: _this.updateSearchText }),
                    React.createElement("div", { className: connectToDataGridClassName },
                        React.createElement("div", { id: 'connect-to-dialog-data-grid-stacking-root', className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogDataGridStackingRoot) }),
                        _this.renderGrid(selectedKeys, updateSelectionForKey),
                        _this.renderFilterPanel(clearSelection)),
                    React.createElement(ConnectToDialogBottomPanel_1.ConnectToDialogBottomPanel, { allowedClasses: _this.props.allowedClasses, client: _this.props.apolloClient, handleButtonClick: _this.onDatasetSelected(selectedKeys, _this.props.apolloClient), selectedDataType: _this.state.selectedDataType, selectedRowIds: selectedKeys, vizPortalWebClientRequester: _this.props.vizPortalWebClientRequester }),
                    _this.state.sessionTimeOut && ConnectToErrorHandling_1.reportConnectToWebClientErrors(['SESSION_EXPIRED']));
            })));
    };
    return ConnectToDialog;
}(React.PureComponent));
exports.ConnectToDialog = ConnectToDialog;
//# sourceMappingURL=ConnectToDialog.js.map